interface IDeleteAccountIconProps {
  className?: string;
}

/**
 * A user silhouette with an X where the shoulders meet — "this account is
 * gone." Monoline, `currentColor`, no fills. Reads cleanly at the home
 * tile's ~40px and at full page scale.
 */
const DeleteAccountIcon = ({ className }: IDeleteAccountIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* head */}
    <circle cx="20" cy="16" r="7" />
    {/* shoulders */}
    <path d="M8 38 v-2 a12 12 0 0 1 19 -9.6" />
    {/* deletion X */}
    <path d="M31 31 l9 9" />
    <path d="M40 31 l-9 9" />
  </svg>
);

export default DeleteAccountIcon;
